<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"
      ><HeaderContent :tabindex="tabIndex"
    /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 公司动态上 -->
      <el-row>
        <el-col :span="24" class="scene_top" v-lazy:background-image="dynamicsImg.picture4">
          <div class="scene_topContent">
            <h1>公司动态</h1>
            <p>NEWS CENTER</p>
          </div>
        </el-col>
      </el-row>
      <!-- 公司动态 -->
      <el-row>
        <el-col :span="24">
          <div class="content_space">
            <el-row style="margin-top: 70px" class="company_dynamics">
              <el-col :span="24">
                <el-row>
                  <el-col :span="8">
                    <div class="dynamics_img">
                      <img v-lazy="dynamicsImg.picture1"/>
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="content">
                      <h4>比《延禧攻略》还要火的上海抢房攻略，果断收藏！</h4>
                      <p>
                        要问今年暑期档，哪部电视剧最火？《延禧攻略》绝对能拔得头筹！
                        因采用了莫兰迪色系而显得舒服高级的画面色调；教科书般的服饰妆容；腹黑聪慧，脾气火爆的女主；善良温柔，实力团宠的皇后加上毒舌钢铁直男的皇上......
                        从播出到完结，一共上了301次热搜，简直成了承包热搜榜的专业户！就连小编也忍不住加入追剧大军，不吃不喝不眠不休地一口气看上十几集。
                      </p>
                      <p>
                        <span>2018-08-31</span
                        ><router-link :to="`/dynamic-details`"
                          ><el-button style="background: #27439f; color: #fff"
                            >了解更多</el-button
                          ></router-link
                        >
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row style="margin-top: 70px" class="company_dynamics">
              <el-col :span="24">
                <el-row>
                  <el-col :span="8">
                    <div class="dynamics_img">
                      <img v-lazy="dynamicsImg.picture2" />
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="content">
                      <h4>藏在写字楼里的隐形成本</h4>
                      <p>
                        随着ip时代的到来，人们越来越追求“颜值”“品质”“舒适性”，办公场地作为企业名片，早已不再是办公场所那么简单，其选址、外立形象、内部环境等,都间接决定了企业的发展。一位成功的老板，必定是一位精打细算的企业家。写字楼的隐形成本就如“怪兽”，但如拿捏的好，则是|
                        助攻神器| 。
                      </p>
                      <p>
                        <span>2018-07-11</span
                        ><router-link :to="`/dynamic-details2`"
                          ><el-button style="background: #27439f; color: #fff"
                            >了解更多</el-button
                          ></router-link
                        >
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row style="margin-top: 70px" class="company_dynamics">
              <el-col :span="24">
                <el-row>
                  <el-col :span="8">
                    <div class="dynamics_img">
                      <img v-lazy="dynamicsImg.picture3" />
                    </div>
                  </el-col>
                  <el-col :span="16">
                    <div class="content">
                      <h4>蓝海购下半年工作经营会议在上海隆重召开</h4>
                      <p>
                        鸡蛋，从外打破是食物，从内打破是生命。人生亦是，从外打破是压力，从内打破是成长。
                        唯有不断的自我突破，与目标较劲，跨越自我，才能迎来胜利的曙光！
                        6月11日，一清早，蓝海购各城市公司负责人集结上海，就蓝海购下半年工作经营会议做了详尽的汇报及工作部署。与此同时，各方城市公司就目标签署了团队军令状。
                      </p>
                      <p>
                        <span>2018-06-11</span
                        ><router-link :to="`/dynamic-details3`"
                          ><el-button style="background: #27439f; color: #fff"
                            >了解更多</el-button
                          ></router-link
                        >
                      </p>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  // 上
  .scene_top {
    // background: url(~@/assets/images/BOSCompanyDynamicsBackground.png) no-repeat;
    background-size: 100% 100%;
    height: 630px;
    width: 100%;
    color: #ffffff;
    position: relative;
    .scene_topContent {
      text-align: left;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      h1 {
        padding-bottom: 23px;
        font-size: 48px;
        font-family: MicrosoftYaHei;
        font-weight: bold;
      }
      p {
        font-size: 18px;
        font-family: MicrosoftYaHeiLight;
        font-weight: 400;
      }
    }
  }

  //公司动态 公共样式
  .content_space {
    background: #fff;
    padding: 0 234px 0px 255px;
    // padding: 0 255px 0px 255px;
    .company_dynamics {
      border-bottom: 1px #dedddd solid;
      padding-bottom: 32px;
      margin-bottom: 62px;
    }
    .title {
      font-size: 30px;
      font-family: MicrosoftYaHeiLight;
      font-weight: bold;
      color: #000000;
      h3 {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 72px;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: 87px;
      }
    }
    .content {
      font-weight: 400;
      text-align: left;
      padding-left: 25px;
      img {
        width: auto;
        height: auto;
        max-width: 100%;
        max-height: 100%;
      }
      h4 {
        font-size: 20px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #040404;
        padding-bottom: 20px;
      }
      > p:nth-of-type(1) {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #aaa7a7;
        line-height: 26px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      > p:nth-of-type(2) {
        font-size: 16px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: #66676a;
        line-height: 40px;
        display: flex;
        justify-content: space-between;
        margin-top: 72px;

        .el-button {
          border-radius: 16px;
          width: 107px;
          height: 33px;
          line-height: 8px;
          a {
            text-decoration: none;
            color: #000000;
          }
        }
      }

      .el-button:hover,
      .el-button:focus {
        background: #fb622d;
        color: #fff;
      }

      .el-button:hover a {
        color: #fff !important;
      }
    }

    .dynamics_img {
      // width: 402px;
      // height: 227px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";
import dynamicsImgOne from "@/assets/images/BOSNewOne.jpg";
import dynamicsImgTwo from "@/assets/images/BOSNewTwo.gif";
import dynamicsImgThree from "@/assets/images/BOSNewThree.jpg";
import dynamicsImgFour from "@/assets/images/BOSCompanyDynamicsBackground.png";


export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {
      tabIndex: "5",
      dynamicsImg:{
        picture1:dynamicsImgOne,
        picture2:dynamicsImgTwo,
        picture3:dynamicsImgThree,
        picture4:dynamicsImgFour,
      },
    };
  },
  methods: {},
  computed: {},
};
</script>